module.exports = __webpack_public_path__ + "static/scale-model-of-the-segway-adventure-in-clearwater-florida-bf2ff382c7259b6b9c6c9d8bdc46a00a.png";